import { useQuery } from "@tanstack/react-query";
import {
  FormBuilderQueryKeys,
  getFormVersion,
  getFormVersions,
} from "@/api/form-builder/formBuilder.queries";
import { useEntityTenantStore } from "@/store/entityTenantStore";

const useActingTenant = (tenantId: string | undefined) => {
  const entityTenant = useEntityTenantStore((state) => state.entityTenant);
  return entityTenant || tenantId || undefined;
};

export const useFormVersions = (formId: string | undefined, tenantId?: string) => {
  const actingTenant = useActingTenant(tenantId);
  return useQuery({
    queryKey: [FormBuilderQueryKeys.versions, actingTenant, formId],
    queryFn: ({ signal }) => getFormVersions(formId as string, actingTenant, signal),
    enabled: Boolean(formId),
  });
};

export const useFormVersion = (
  formId: string | undefined,
  version: number | undefined,
  tenantId?: string,
) => {
  const actingTenant = useActingTenant(tenantId);
  return useQuery({
    queryKey: [FormBuilderQueryKeys.version, actingTenant, formId, version],
    queryFn: ({ signal }) =>
      getFormVersion(formId as string, version as number, actingTenant, signal),
    enabled: Boolean(formId && version),
  });
};
